/**
 * Top-level PWA UX bundle. Mount once near the app root so every route
 * inherits the offline banner and install experience.
 */

import { InstallExperience } from './install-experience'
import { OfflineBanner } from './offline-banner'

export function PwaShell() {
  return (
    <>
      <OfflineBanner />
      <InstallExperience />
    </>
  )
}
